import { h, Component, Prop, Element } from '@stencil/core';
import { lazyImageBackground } from '../../dom-utils/lazyImageBackground';

@Component({
  shadow: true,
  styleUrl: 'igws-img-bg.less',
  tag: 'igws-img-bg',
})

export class ImageBackgroungComponent {
  timeoutID: any;

  @Element() private el?: HTMLIgwsImgBgElement;

  /** Background image is Adaptive */
  @Prop() isAdaptive: string = '';
  /** Background image smaller rendition */
  @Prop() smallerRendition: string = '';
  /** Background image small rendition */
  @Prop() smallRendition: string = '';
  /** Background image medium rendition */
  @Prop() mediumRendition: string = '';
  /** Background image high rendition */
  @Prop() highRendition: string = '';
  /** Background image higher rendition */
  @Prop() higherRendition: string = '';
  /** Background image full high rendition */
  @Prop() fullHighRendition: string = '';

  componentDidLoad() {
    this.lazyLoad();
  }

  lazyLoad() {
    const options = {
      element: this.el as HTMLIgwsImgBgElement,
      isAdaptive: this.isAdaptive,
      media_src: [
        this.smallerRendition,
        this.smallRendition,
        this.mediumRendition,
        this.highRendition,
        this.higherRendition,
        this.fullHighRendition,
      ],
    };
    lazyImageBackground(options);
  }

  render() {
    return <slot />;
  }
}
